import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import { useActiveStudent } from '../../hooks/useActiveStudent';
import { useGetThreadQuery } from '../../store/api/localApi';
import ThreadView from '../messages/ThreadView';

/** /parent/family/threads/:threadId — a conversation read from the inbox. A family page: the active child is untouched. */
const FamilyThreadPage: React.FC = () => {
  const { threadId = '' } = useParams<{ threadId: string }>();
  const { children } = useActiveStudent();
  const { data } = useGetThreadQuery(threadId, { skip: !threadId });
  const child = children.find((c) => c.id === data?.thread.studentId);
  const childName = child ? child.firstName || child.displayName : 'your child';
  return (
    <div className="py-6" data-testid="family-thread">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 space-y-5">
        <Link to="/parent/family/inbox" data-testid="family-thread-back" className="inline-flex items-center gap-1.5 text-sm text-gray-500 hover:text-gray-700">
          <ArrowLeftIcon className="h-4 w-4" /> Inbox
        </Link>
        <ThreadView threadId={threadId} title={`About ${childName}`} />
      </div>
    </div>
  );
};
export default FamilyThreadPage;
